"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgLeafFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M27 4c-.53 0-12.89.38-18.19 5.68a9.57 9.57 0 000 13.53l.11.09c.1-.49.22-1 .37-1.48a19.24 19.24 0 015.8-9.24l1.31 1.64a17.29 17.29 0 00-5.09 8.19 18.35 18.35 0 00-.53 2.3 18.24 18.24 0 00.04 6.29h2a15.76 15.76 0 01-.22-5.45 9.53 9.53 0 009.67-2.34C27.94 17.59 28 5.51 28 5V4z" })));
}
exports.default = SvgLeafFilled;
//# sourceMappingURL=LeafFilled.js.map